import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row no-wrap justify-center items-center" }
const _hoisted_2 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(_component_q_btn, {
    disable: _ctx.disabled,
    class: "fit",
    color: _ctx.getBrandColor,
    "text-color": "white",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        (_ctx.getMessengerIconLink)
          ? (_openBlock(), _createBlock(_component_q_icon, {
              key: 0,
              name: _ctx.getMessengerIconLink
            }, null, 8, ["name"]))
          : _createCommentVNode("", true),
        (_ctx.showText)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "q-ml-sm",
              textContent: _toDisplayString(_ctx.$t(_ctx.button.text))
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["disable", "color"]))
}